<!--  -->
<template>
  <div class="">
    <Pdf :pdfUrl="lectureUrl" />
  </div>
</template>

<script>
import Pdf from '@/pages/examOutline/components/pdf.vue';

export default {
  components: {
    Pdf,
  },
  data() {
    return {
      lectureUrl: '',
      name: '',
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {
    const { lectureUrl, name } = this.$route.query;
    this.lectureUrl = lectureUrl;
    this.name = name;
    document.title = name;
  },
};
</script>